module.exports = __webpack_public_path__ + "static/media/svg_1_3_1_VOP_D14_A.e53739de.svg";


//////////////////
// WEBPACK FOOTER
// ./src/content/chapters/01/03/assets/svg_1_3_1_VOP_D14_A.svg
// module id = 388
// module chunks = 0